var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy158Selected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "podklad"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fcac04",
    d: "M89.6,4c3.1,0,5.6,2.5,5.6,5.6v80c0,3.1-2.5,5.6-5.6,5.6h-80c-3.1,0-5.6-2.5-5.6-5.6v-80C4,6.5,6.5,4,9.6,4 H89.6 M89.6,0h-80C4.3,0,0,4.3,0,9.6v80c0,5.3,4.3,9.6,9.6,9.6h80c5.3,0,9.6-4.3,9.6-9.6v-80C99.2,4.3,94.9,0,89.6,0L89.6,0z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fcac04",
    d: "M50.9,27.8h-12c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0c0,0,0,0,0,0 c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.3-0.1,0.4v24.1v17.9c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1V53.9h11c7.2,0,13-5.8,13-13 C64,33.6,58.1,27.8,50.9,27.8z M58.7,48.6c-2,2-4.8,3.2-7.8,3.2h-11V29.8h11c3.1,0,5.8,1.2,7.8,3.2c2,2,3.2,4.8,3.2,7.8 C62,43.9,60.7,46.6,58.7,48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcac04",
    d: "M67.4,16.5H31.8c-8,0-14.6,6.5-14.6,14.6v35.6c0,8,6.5,14.6,14.6,14.6h35.6c8,0,14.6-6.5,14.6-14.6V31.1 C82,23.1,75.5,16.5,67.4,16.5z M80,66.7c0,3.5-1.4,6.6-3.7,8.9c-2.3,2.3-5.4,3.7-8.9,3.7H31.8c-3.5,0-6.6-1.4-8.9-3.7 c-2.3-2.3-3.7-5.4-3.7-8.9V31.1c0-3.5,1.4-6.6,3.7-8.9c2.3-2.3,5.4-3.7,8.9-3.7h35.6c3.5,0,6.6,1.4,8.9,3.7 c2.3,2.3,3.7,5.4,3.7,8.9V66.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy158Selected);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-158-selected.06c3bf1c863df3a5630c4c24dffb9306.svg";
export { ForwardRef as ReactComponent };